import React, { useState } from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { Sparkles, Loader2 } from 'lucide-react';
import { aiNarrativeApi } from '../lib/api';
import { toast } from 'sonner';

export default function AINarrativePanel({ scope, contextData, title = 'AI Summary for Your Organization' }) {
  const [narrative, setNarrative] = useState('');
  const [org, setOrg] = useState('');
  const [loading, setLoading] = useState(false);

  const generate = async () => {
    setLoading(true);
    try {
      const r = await aiNarrativeApi.generate(scope, contextData);
      setNarrative(r.data.narrative);
      setOrg(r.data.org || '');
    } catch { toast.error('AI narrative unavailable'); }
    finally { setLoading(false); }
  };

  return (
    <Card className="careiq-card bg-gradient-to-br from-[#F5F3FF] to-[#EFF6FF] border-[#C4B5FD]/40" data-testid={`ai-narrative-${scope}`}>
      <CardContent className="p-4 space-y-3">
        <div className="flex items-center justify-between gap-2">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-[#7C3AED] to-[#0E7490] flex items-center justify-center">
              <Sparkles className="w-4 h-4 text-white" />
            </div>
            <div>
              <div className="text-sm font-semibold text-[#0A2342]">{title}</div>
              {org && <div className="text-[10px] text-[#64748B]">For {org}</div>}
            </div>
          </div>
          <Button size="sm" onClick={generate} disabled={loading} className="careiq-btn-primary" data-testid={`ai-narrative-btn-${scope}`}>
            {loading ? <Loader2 className="w-3.5 h-3.5 mr-1 animate-spin" /> : <Sparkles className="w-3.5 h-3.5 mr-1" />}
            {narrative ? 'Regenerate' : 'Generate AI Insight'}
          </Button>
        </div>
        {narrative ? (
          <p className="text-sm text-[#0A2342] leading-relaxed whitespace-pre-wrap">{narrative}</p>
        ) : (
          <p className="text-xs text-[#64748B]">Click "Generate AI Insight" for a Claude-powered narrative summary of this dashboard, scoped to your organization.</p>
        )}
      </CardContent>
    </Card>
  );
}
